(() => {
  if (customElements.get('zuqo-clean-video')) return;
  if (!customElements.get('zuqo-reel-gallery')) customElements.define('zuqo-reel-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        const track = this.querySelector('.zuqo-banner-reels');
        if (track) this.resizeObserver?.observe(track);
        return;
      }
      this.ready = true;
      const track = this.querySelector('.zuqo-banner-reels');
      const dots = Array.from(this.querySelectorAll('[data-reel-dot]'));
      if (!track || !dots.length) return;
      let frame = null;
      const update = () => {
        frame = null;
        if (!window.matchMedia('(max-width:989px)').matches || !track.clientWidth) return;
        const index = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === index)));
      };
      const schedule = () => { if (frame === null) frame = requestAnimationFrame(update); };
      track.addEventListener('scroll', schedule, { passive:true });
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-reel-dot]');
        if (!dot || !this.contains(dot)) return;
        track.scrollTo({ left:Number(dot.dataset.reelDot) * track.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      });
      this.resizeObserver = new ResizeObserver(schedule);
      this.resizeObserver.observe(track);
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
  });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.setVisible(entry.isIntersecting && entry.intersectionRatio >= 0.2));
  }, { threshold: [0, 0.2] }) : null;
  customElements.define('zuqo-clean-video', class extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.visible = false;
        this.sound = this.querySelector('.zuqo-clean-video__sound');
        this.sound.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const video = this.ensureVideo();
          if (!video) return;
          const muted = !video.muted;
          if (!muted) this.closest('[data-zuqo-video-group]')?.querySelectorAll('zuqo-clean-video').forEach(player => {
            if (player !== this) player.setMuted(true);
          });
          this.setMuted(muted);
          this.resume();
        });
      }
      if (observer) observer.observe(this);
      else this.setVisible(true);
    }
    disconnectedCallback() { observer?.unobserve(this); this.visible = false; this.video?.pause(); }
    ensureVideo() {
      if (this.video) return this.video;
      const template = this.querySelector('template');
      if (!template) return null;
      this.appendChild(template.content.cloneNode(true));
      template.remove();
      this.video = this.querySelector('video');
      this.video.muted = true;
      this.video.loop = true;
      this.video.addEventListener('playing', () => { this.querySelector('.zuqo-clean-video__cover').hidden = true; });
      return this.video;
    }
    setMuted(muted) {
      if (this.video) this.video.muted = muted;
      this.sound.setAttribute('aria-pressed', String(!muted));
      this.sound.setAttribute('aria-label', muted ? this.sound.dataset.soundOn : this.sound.dataset.soundOff);
      this.sound.querySelector('[data-muted-icon]').hidden = !muted;
      this.sound.querySelector('[data-sound-icon]').hidden = muted;
    }
    setVisible(visible) {
      this.visible = visible;
      if (visible && !document.hidden) this.resume();
      else {
        this.video?.pause();
        if (this.closest('[data-zuqo-video-group]')) this.setMuted(true);
      }
    }
    resume() {
      if (!this.visible || document.hidden) return;
      const video = this.ensureVideo();
      if (video) video.play().catch(() => {});
    }
  });
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('zuqo-clean-video').forEach(player => player.setVisible(player.visible));
  });
})();
